import CompaniesTable from './CompaniesTable'
export default CompaniesTable
